import { resolveSiteSocialUrl, SITE_SOCIAL_LINKS } from "./siteSocialLinks";

/**
 * When true, UI shows iOS/Android install links, marketing, and subscription lines that reference native apps.
 * Set REACT_APP_NATIVE_IOS_ANDROID_AVAILABLE=true when App Store / Play builds are published.
 */
export const NATIVE_IOS_ANDROID_AVAILABLE =
    typeof process !== "undefined" && process.env.REACT_APP_NATIVE_IOS_ANDROID_AVAILABLE === "true";

export { SITE_SOCIAL_LINKS };

/** Sliding Puzzle Quest — iOS App Store listing (REACT_APP_APP_STORE_URL). */
export const SLIDING_PUZZLE_QUEST_APP_STORE_URL = resolveSiteSocialUrl(
    process.env.REACT_APP_APP_STORE_URL,
    SITE_SOCIAL_LINKS.appStore,
);

/** Sliding Puzzle Quest — Google Play listing. */
export const SLIDING_PUZZLE_QUEST_GOOGLE_PLAY_URL =
    "https://play.google.com/store/apps/details?id=com.pzl.android.sliding";

/** Jigsaw Muse — Google Play listing. */
export const JIGSAW_MUSE_GOOGLE_PLAY_URL =
    "https://play.google.com/store/apps/details?id=com.puzint.jigsaw.app";

/** Word Wheel Quest — Google Play listing. */
export const WORD_WHEEL_QUEST_GOOGLE_PLAY_URL =
    "https://play.google.com/store/apps/details?id=com.puzint.wordwheel.app";

/** Word Wheel Quest — iOS App Store listing. */
export const WORD_WHEEL_QUEST_APP_STORE_URL =
    "https://apps.apple.com/us/app/word-wheel-quest/id6787691583";

/** When true, show the Sliding Puzzle Quest App Store badge on browse/marketing surfaces. */
export const SHOW_SLIDING_APP_STORE_BADGE = false;

/** When true, show the Sliding Puzzle Quest Google Play badge on browse/marketing surfaces. */
export const SHOW_SLIDING_GOOGLE_PLAY_BADGE = true;

/** When true, show the Jigsaw Muse Google Play badge on browse/marketing surfaces. */
export const SHOW_JIGSAW_GOOGLE_PLAY_BADGE = true;

/** When true, show the Word Wheel Quest Google Play badge on browse/marketing surfaces. */
export const SHOW_WORD_WHEEL_GOOGLE_PLAY_BADGE = true;

/** When true, show the Word Wheel Quest App Store badge on browse/marketing surfaces. */
export const SHOW_WORD_WHEEL_APP_STORE_BADGE = true;